var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_28",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 15
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_28)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73383 11.9735C6.91433 11.9735 8.00488 11.6138 8.91555 11.0066L12.2097 14.3008C12.4684 14.5594 12.8956 14.5594 13.1653 14.3008L13.8062 13.6599C14.0648 13.4014 14.0648 12.9741 13.8062 12.7043L10.5008 9.42141C11.1078 8.51074 11.4677 7.42019 11.4677 6.23969C11.4677 3.08046 8.89306 0.505859 5.73383 0.505859C2.5746 0.505859 0 3.08046 0 6.23969C0 9.39881 2.56336 11.9735 5.73383 11.9735V11.9735ZM5.73381 2.75436C7.65633 2.75436 9.21908 4.31711 9.21908 6.23964C9.21908 8.16216 7.65633 9.72491 5.73381 9.72491C3.81129 9.72491 2.24854 8.16216 2.24854 6.23964C2.24854 4.31712 3.81129 2.75436 5.73381 2.75436V2.75436Z",
    fill: "#ACACAC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.c0f9589735b822d62eefc2a9e34c5448.svg";
export { ForwardRef as ReactComponent };